<template>
  <b-navbar
    toggleable="lg"
    type="light"
    variant="white"
    class="shadow-sm mb-3"
    style="padding: 15px"
  >
    <b-navbar-brand v-if="$store.state.showSidebar">
      <font-awesome-icon @click="showSidebarMenu" class="mr-2" icon="list" />
    </b-navbar-brand>
      <b-navbar-brand v-else>
        <Logo
          :logoProps="logo"
        />
    </b-navbar-brand>
    <b-navbar-nav class="ml-auto">
      <!-- <b-nav-item-dropdown v-if="userType == '3'" right>
        <template v-slot:button-content>
          <em>
            <span style="color: #3b3e66">Select Theme</span>
          </em>
        </template>
        <b-dropdown-item @click="changeAppTheme('1')">Theme 1</b-dropdown-item>
        <b-dropdown-item @click="changeAppTheme('2')">Theme 2</b-dropdown-item>
      </b-nav-item-dropdown> -->
      <b-nav-item-dropdown right>
        <template v-slot:button-content>
          <em>
            <b-avatar
              v-if="profileImage"
              variant="info"
              :src="profileImage"
            ></b-avatar>
            <font-awesome-icon v-else icon="user" />&nbsp;
            <span style="color: #3b3e66; font-weight: bold">{{
              nameToShow
            }}</span>
          </em>
        </template>
        <b-dropdown-item to="/update-profile">{{
          $t("updateProfile")
        }}</b-dropdown-item>
        <b-dropdown-item @click="onLogout">{{
          $t("signOutBtnText")
        }}</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>
</template>
<script>
import { Helper } from "../../helpers";
import { HTTP } from "../../utils/HTTP";
import { EventBus } from "@/event-bus.js";
import Logo from '../logo/logo.vue';

export default {
  name: "HmployeeHeader",
  components: {
    Logo
  },
  data() {
    return {
      userType: null,
      userFullName: null,
      userFirstName: null,
      userLastname: null,
      nameToShow: null,
      userId: null,
      profileImage: null,
      
      newDashbaordThemePath: {
        path: '/new-dashboard',
      },
      oldDashbaordThemePath: {
        path: '/dashboard',
      },
       logo: {
        width: "auto",
        height: "35px",
      },
    };
  },

  mounted() {
    this.userId = localStorage.getItem("userId");
    this.userType = localStorage.getItem("userType");
    this.getUserDetail();
  },
  methods: {
    showSidebarMenu() {
      EventBus.$emit("ToggleCollapse", "");
    },
    async getUserDetail() {
      let datail = JSON.parse(localStorage.getItem("userDetail"));
      this.profileImage = datail.profile_img_url;
      this.nameToShow = datail.first_name + " " + datail.last_name;
    },
    async deleteRefreshTokken() {
      try {
        let result = await HTTP("get", "logout", null);
        return result;
      } catch (error) {
        return [error];
      }
    },
    onLogout() {
      this.deleteRefreshTokken();
      this.$store.commit("SET_ACCESS_TOKEN", null);
      this.$store.state.accessToken = null;
      localStorage.clear();
      Helper.makeToast(
        this.$bvToast,
        "success",
        this.$t("toast.logoutSuccess"),
        this.$t("toast.title")
      );
      this.$router.replace("/");
    },
    changeAppTheme(selectedTheme){
      if(selectedTheme == '2'){
        this.$store.state.showSidebar = true;
        localStorage.setItem('showSidebar', '1');
      }
      else if(selectedTheme == '1'){
        this.$store.state.showSidebar = false;
        localStorage.setItem('showSidebar', '2');
      }
        this.$router.push("/dashboard")
    }
  },
};
</script>
<style scoped>
.capitalize {
  text-transform: capitalize;
}
.cogs:hover {
  font-size: 18px;
  color: blueviolet;
  animation: spin 3000ms;
}
</style>